<template>
  <div data-test-id="product-reviews-media-carousel">
    <vf-carousel
      v-style:w="{ sm: '15rem', md: '22rem', lg: '37rem' }"
      :aria-label="`${$t.userSubmitted} ${$t.products.one}`"
      class="m-a flex justify-center"
      class-controls="-mx-10"
      :loop="reviewUgcMedia.length > 3"
      role="group"
    >
      <base-button
        v-for="(review, i) in reviewUgcMedia"
        :key="i"
        :aria-label="`${$t.reviewUgcViewInPopup} - ${i + 1}`"
        style="margin: 0 0.25rem"
        @click="openReviewUgc(i)"
      >
        <base-picture
          v-if="review.media[0].type === 'image'"
          :alt="review.media[0].caption"
          fit="cover"
          height="112"
          :props-img="{ class: 'aspect-square w-a', style: 'height: 7rem' }"
          :src="review.media[0].uri"
          width="112"
        />
        <base-video
          v-else-if="review.media[0].type === 'video'"
          class="aspect-square"
          :src="review.media[0].uri"
          style="height: 7rem"
        />
      </base-button>
    </vf-carousel>
  </div>
</template>

<script lang="ts" setup>
const props = defineProps<{
  productId: string
  reviewUgcMedia: any
}>()

const { $t } = useNuxtApp()
const { DialogReviewUgc } = useDialogsStore()

const openReviewUgc = (activeIndex: number) => {
  DialogReviewUgc.keep().open({
    productId: props.productId,
    reviewUgcMedia: props.reviewUgcMedia,
    activeIndex,
    isCarousel: true,
  })
}
</script>
